import React from "react";
import { useParams, Link } from "react-router-dom";
import SEO from "../components/SEO";
import categoriesData from "../data/categories.json"; // <-- Import JSON

export default function CategoryPage() {
  const { slug } = useParams();
  const cat = categoriesData[slug];

  if (!cat) {
    return (
      <div className="container my-5">
        <Helmet>
          <title>Category Not Found | 100 Eyes Technologies</title>
          <meta
            name="description"
            content="We couldn't find the category you were looking for. Visit 100 Eyes Technologies for more digital business solutions."
          />
          <meta property="og:title" content="Category Not Found" />
          <meta
            property="og:description"
            content="We couldn't find the category you were looking for."
          />
        </Helmet>
        <h1>Category not found</h1>
        <p>We couldn't find the category you were looking for.</p>
        <p>
          <Link to="/">Back to Home</Link>
        </p>
      </div>
    );
  }

  return (
    <div className="container my-5">
      <SEO
        title={cat.meta.title.replace(/\s*\|\s*100 Eyes Technologies$/i, '')}
        description={cat.meta.description}
        keywords={cat.meta.keywords}
        image={cat.meta.image}
        canonical={`https://100eyestechnologies.com/${slug}`}
      >
        {/* Preserve Open Graph & Twitter tags for category pages */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={cat.meta.title} />
        <meta property="og:description" content={cat.meta.description} />
        <meta property="og:image" content={cat.meta.image} />
        <meta property="og:url" content={`https://100eyestechnologies.com/${slug}`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={cat.meta.title} />
        <meta name="twitter:description" content={cat.meta.description} />
        <meta name="twitter:image" content={cat.meta.image} />
      </SEO>

      <div className="row g-4">
        <div className="col-md-5">
          <img src={cat.image} alt={cat.title} className="img-fluid rounded" />
        </div>
        <div className="col-md-7">
          <h1>{cat.title}</h1>
          <p className="lead">{cat.brief}</p>
          <h5>What we offer</h5>
          <ul>
            {cat.details.map((d) => (
              <li key={d}>{d}</li>
            ))}
          </ul>
          <p>
            Interested in launching a store in this category?{" "}
            <Link to="/contact-us">Contact our sales team</Link> to get started
            with a tailored solution.
          </p>
        </div>
      </div>
    </div>
  );
}
